/**
 * Set a cookie to remember the user's choice.
 *
 * @param {HTMLElement} alertBanner - The alert banner element.
 */
function setCookie(alertBanner) {
	// Set a one-week cookie to remember the user's choice.
	const effectiveDate = alertBanner.getAttribute('data-effective-date');
	const date = new Date();
	date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);
	const expires = `expires=${date.toUTCString()}`;
	document.cookie = `SBW_ALERT_BANNER=${effectiveDate}; ${expires}; path=/; Secure SameSite=Strict`;
}

function animateToClose(alertBanner) {
	const alertBannerClose = alertBanner.querySelector(
		'[data-action="alert-banner-close"]'
	);

	alertBanner.classList.add('shrink-height');
	alertBannerClose.style.display = 'none';

	alertBanner.addEventListener(
		'animationend',
		function handleShrinkHeight() {
			alertBanner.classList.remove('shrink-height');
			alertBanner.style.display = 'none';
		},
		{ once: true }
	);
}

/**
 * Handle closing the alert banner.
 */
function handleAlertBanner() {
	const alertBanner = document.querySelector('[data-element="alert-banner"]');

	if (!alertBanner) {
		return;
	}

	// Check if the user has already closed the alert banner.
	const cookies = document.cookie.split(';');
	const cookie = cookies.find((cookieContent) =>
		cookieContent.includes('SBW_ALERT_BANNER')
	);
	const effectiveDate = alertBanner.getAttribute('data-effective-date');
	// If the cookie is set and the effective date matches the cookie, close the alert banner.
	if (!cookie || !cookie.includes(effectiveDate)) {
		alertBanner.style.display = 'block';
	}

	const alertBannerClose = alertBanner.querySelector(
		'[data-action="alert-banner-close"]'
	);

	alertBannerClose.addEventListener('click', () => {
		setCookie(alertBanner);
		animateToClose(alertBanner);
	});
}

export { handleAlertBanner };
